module.exports = __webpack_public_path__ + "static/img/ic_gy_fw_zl.b0c921b2.png";